var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_26_10",
    "data-name": "Componente 26 \\u2013 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_326",
    "data-name": "Rect\\xE1ngulo 326",
    width: 30,
    height: 30,
    fill: "#20164d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_260",
    "data-name": "Grupo 260",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_659",
    "data-name": "Trazado 659",
    d: "M23.614,11.667l-1.532-1.532a1.086,1.086,0,0,0-.765-.316,1.1,1.1,0,0,0-.766.316l-7.386,7.4L9.856,14.212a1.085,1.085,0,0,0-1.531,0L6.793,15.744a1.085,1.085,0,0,0,0,1.531L12.4,22.882a1.088,1.088,0,0,0,1.531,0L23.615,13.2a1.088,1.088,0,0,0,.316-.766h0a1.094,1.094,0,0,0-.316-.765",
    transform: "translate(-0.405 -0.614)",
    fill: "#20164d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_660",
    "data-name": "Trazado 660",
    d: "M15,0A15,15,0,1,0,30,15,15,15,0,0,0,15,0m0,27.188A12.188,12.188,0,1,1,27.188,15,12.2,12.2,0,0,1,15,27.188",
    fill: "#20164d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check_icon.d51e3c5885f9b06a7d3ca92c1f18b270.svg";
export { ForwardRef as ReactComponent };